module.exports = __webpack_public_path__ + "static/media/searchIcon.985127f8.svg";